import { ref, onMounted, onUnmounted } from 'vue';

import { getCtr, ModalController } from '../modal-helper';
import { until } from '@vueuse/core';

export function useModal() {
	const mCtr = ref<ModalController | undefined>(undefined);
	const modal = ref<HTMLIonModalElement | undefined>(undefined);

	async function dismiss(data?: any, role?: string) {
		return mCtr.value?.dismiss(data, role);
	}

	async function onWillDismiss() {
		await until(() => modal.value).toBeTruthy();
		return modal.value?.onWillDismiss();
	}

	onMounted(async () => {
		mCtr.value = await getCtr();
		modal.value = await mCtr.value.getTop();
	});

	onUnmounted(() => {
		mCtr.value = undefined;
		modal.value = undefined;
	});

	return {
		dismiss,
		onWillDismiss,
	};
}
